import {Component} from "@angular/core";
import {select} from "@angular-redux/store";
import {Observable} from "rxjs";
import {Router} from "@angular/router";
import {environment} from "../../../../environments/environment";
import {VersionSettings} from "../../../pb-screen/static/client/versionSettings";

@Component({
  selector: "application-information",
  templateUrl: "./application-information.component.html",
  styleUrls: ["./application-information.component.scss"]
})
export class ApplicationInformationComponent {

  @select("httpRequestPending") httpRequestPending$: Observable<boolean>;

  thisYear = new Date().getFullYear();
  isProduction = environment.production;
  isSaasMode = environment.saasMode;

  constructor(private router: Router) {}

  get versionNumber(): string {
    const base = VersionSettings.versionNumber;
    const url = this.router.url;

    const isPerformanceOptimized =
      (url.startsWith('/planning') && environment.targetPlanningToolApiForPlanBoard) ||
      (url.startsWith('/week-planning') && environment.targetPlanningToolApiForMultiDayPlanBoard) ||
      (url.startsWith('/pb-screen') && environment.targetPlanningToolApiForPBScreen) ||
      (url.startsWith('/depot-in') && environment.targetPlanningToolApiForDepotInScreen) ||
      (url.startsWith('/depot-out') && environment.targetPlanningToolApiForDepotOutScreen);

    return isPerformanceOptimized ? `${base}-PerformanceOptimized` : base;
  }
}
